import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { ManualNettingEventImpl } from "../model/impl/ManualNettingEventImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class ManualNettingEventImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: ManualNettingEventImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.hasPortfolioId != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        ManualNettingEventImplEncoder.fidTypeMap.get(1),
        false,
        encodable.hasPortfolioId,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.portfolioId != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        ManualNettingEventImplEncoder.fidTypeMap.get(2),
        false,
        encodable.portfolioId,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.orderIds != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        true,
        ManualNettingEventImplEncoder.fidTypeMap.get(3),
        false,
        encodable.orderIds,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        ManualNettingEventImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,ManualNettingEventImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.Boolean"],
    [2, "java.lang.String"],
    [3, "java.lang.String"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: ManualNettingEventImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            ManualNettingEventImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.hasPortfolioId = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ManualNettingEventImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.portfolioId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            ManualNettingEventImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.orderIds = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ManualNettingEventImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,ManualNettingEventImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return ManualNettingEventImplEncoder.fidTypeMap.has(fid);
  }
}
